import {
  API_BASE_QUICK_QUOTE,
  IS_AUTH_TOKEN_NEEDED,
  NODE_ENV,
  QUICK_QUOTE_REDIRECTION,
  X_API_KEY_QUICK_QUOTE,
} from "@/config/config";
import { setErrorData } from "@/features/error/errorSlice";
import {
  hideLoader,
  hideSkeleton,
  showLoader,
  showSkeleton,
} from "@/features/loader/loaderSlice";
import {
  sendAxiosDefaultErrorAnalytics,
  sendErrorAnalytics,
} from "@/helpers/analytics";
import logger from "@/helpers/logger";
import { compareTwoStr } from "@/helpers/utils";
import { store } from "@/redux/store";
import axios from "axios";
import isEmpty from "lodash/isEmpty";

const axiosInstance = axios.create({
  baseURL:
    (API_BASE_QUICK_QUOTE && `${API_BASE_QUICK_QUOTE}`) ||
    "http://localhost:3001",
});

axiosInstance.interceptors.request.use(async (config) => {
  if (IS_AUTH_TOKEN_NEEDED == "true") {
    let token = "";
    if (typeof window !== "undefined") {
      // When api call is made from browser
      token = localStorage.getItem("token") || "";
      // For test & dev, we will call the token as soon as it expires whenever api call is made.
      if (["dev"].includes(NODE_ENV)) {
        if (!token) {
          token = localStorage.getItem("token") || "";
          window.location.href = QUICK_QUOTE_REDIRECTION;
        }
      }
    } else {
      // When api call is made from server side
      // window.location.href = QUICK_QUOTE_REDIRECTION;
      token = localStorage.getItem("token") || "";
    }

    if (isEmpty(config.headers) || isEmpty(config.headers.Authorization)) {
      config.headers.Authorization = `${token}`;
      config.headers["x-api-key"] = X_API_KEY_QUICK_QUOTE;
    }
  }

  // config.headers["X-Trace-Id"] = uuidv4();

  if (!config.hideLoader) {
    store.dispatch(showLoader());
  }
  if (config.showSkeleton) {
    store.dispatch(showSkeleton());
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (!response.config.hideLoader) {
      store.dispatch(hideLoader());
    }
    if (response.config.showSkeleton) {
      store.dispatch(hideSkeleton());
    }
    return response.data;
  },
  (error) => {
    const defaultErrorCode = "FE_DEF_ERR";
    const timeoutErrorCode = "FE_TIMEOUT_ERR";
    const timeoutCodeByAxios = "ECONNABORTED";
    const defaultMsg =
      "Oops! This shouldn't have happened. We are working to get this fixed as soon as we can. Request you to try again in some time.";
    if (!error.config?.hideLoader) {
      store.dispatch(hideLoader());
    }
    if (error.config?.showSkeleton) {
      store.dispatch(hideSkeleton());
    }
    logger.log("AXIOS RESPONSE ERROR --> ", error);
    if (!error.config?.hideErrorModal) {
      let msg = error?.response?.data?.message
        ? error?.response?.data?.message
        : defaultErrorCode.concat(`: ${defaultMsg}`);

      if (compareTwoStr(error?.code, timeoutCodeByAxios)) {
        msg = timeoutErrorCode.concat(`: ${defaultMsg}`);
      }

      store.dispatch(
        setErrorData({
          errorData: {
            show: true,
            showCommonModal: true,
            status: error?.response?.status,
            msg,
          },
        })
      );
    }

    let msg = error?.response?.data?.message
      ? error?.response?.data?.message
      : defaultErrorCode.concat(`: ${defaultMsg}`);

    if (compareTwoStr(error?.code, timeoutCodeByAxios)) {
      msg = timeoutErrorCode.concat(`: ${defaultMsg}`);
      sendAxiosDefaultErrorAnalytics(timeoutErrorCode, error?.config, msg);
    } else if (msg === defaultErrorCode.concat(`: ${defaultMsg}`)) {
      msg = error?.response?.status?.toString().concat(`:- ${msg}`);
      sendAxiosDefaultErrorAnalytics(
        defaultErrorCode,
        error?.response?.config,
        msg
      );
    } else {
      msg = error?.response?.status?.toString().concat(`:- ${msg}`);
      sendErrorAnalytics(error?.response?.config, msg);
    }

    return Promise.reject(error?.response);
  }
);

export default axiosInstance;
